// extracted by mini-css-extract-plugin
export default {"button":"Activate_button__nv9Qj","cautionTextColor":"Activate_cautionTextColor__BsQZZ"};